// ✅ Enhanced Preloader.js
import React from "react";
import Spinner from "assets/images/svg/preloader.svg";
import "./loader.css";
import { useTranslation } from "react-i18next";
import { Spin, Progress } from "antd";

export function PreloaderComponent() {
  return (
    <section
      style={{
        height: "100vh",
        width: "100%",
        padding: "calc(250px + 1.5625vw) 0",
        textAlign: "center",
      }}
    >
      <img
        style={{
          height: "50px",
          width: "50px",
          margin: "0 auto",
        }}
        src={Spinner}
        alt="Loading"
        draggable={false}
      />
    </section>
  );
}

export function Preloader({ loading }) {
  // for entire page, to indicate loading on refresh
  if (loading) {
    return (
      <div className="content-loader">
        {/* <span className="loader" /> */}
        <Spin className="spin-loader" size="large" />
      </div>
    );
  } else {
    return null;
  }
}

export function PreloaderWithProgress({
  loading,
  percent,
  onCancel,
  displayText,
}) {
  const { t } = useTranslation();
  const text = displayText || t("please_wait");
  if (loading) return null;

  const isProgressMode = typeof percent === "number";

  if (!isProgressMode) return null; // hide loader if percent not provided

  return (
    <div className="progress-overlay">
      <button className="close-button" onClick={onCancel}>
        &times;
      </button>
      <div className="loader-container">
        <div className="progress-card">
          <div className="custom-progress-card">
            <Progress
              type="circle"
              percent={percent}
              strokeColor={{
                "0%": "#3bc1cd",
                "100%": "#00bcd4",
              }}
              trailColor="white"
              strokeWidth={10}
              size={120}
            />
          </div>
          <div className="dot-loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p className="progress-text">{text}</p>
        </div>
      </div>
    </div>
  );
}

export function PreloaderLoadMore({ extraClass }) {
  return (
    <div
      className={`d-flex justify-content-center align-items-center ${
        extraClass ? extraClass : ""
      }`}
    >
      <span className="loader" />
    </div>
  );
}
